@import '../styles/_vars.css';

.header {
  background-color: var(--color-bg-header);
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;
  padding-top: 1em;
  padding-bottom: 1em;
}

@media screen and (min-width: 770px) {
  .header {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .right{
    display: flex;
    justify-content: flex-end;
    column-gap: 2.5rem;
  }
}

@media screen and (min-width: 1441px) {
  .header {
    padding-left: 5rem;
    padding-right: 7rem;
  }
}

.logo {
  width: auto;
  max-height: 70px;
}

.pointer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 1rem;
  text-decoration: none;
  padding-top: 4px;
  padding-bottom: 4px;
}

.pointer img {
  padding-top: 5px;
}

